import React from 'react';
import { STATE_UI, ROLLUP_ORDER } from './chargeUi';
import type { Rollup } from './types';

/** Dot + count + label chips for each non-zero battery state. Shared by the
 *  charger card, the detail drawer, and the dashboard widget. */
export default function RollupChips({ rollup, labels = true }: { rollup: Rollup | null; labels?: boolean }) {
  if (!rollup) return <span className="text-xs text-on-surface-variant">—</span>;
  const items = ROLLUP_ORDER.filter((s) => (rollup.counts?.[s] || 0) > 0);
  if (!items.length) return <span className="text-xs text-on-surface-variant">No batteries</span>;
  return (
    <div className="flex flex-wrap gap-x-3 gap-y-1">
      {items.map((s) => (
        <span key={s} className="flex items-center gap-1.5 text-xs">
          <span className={`w-2 h-2 rounded-full ${STATE_UI[s].dot}`} />
          <span className={`font-medium ${STATE_UI[s].text}`}>{rollup.counts[s]}</span>
          {labels && <span className="text-on-surface-variant">{STATE_UI[s].label}</span>}
        </span>
      ))}
    </div>
  );
}
